import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Layout, PageHeader } from "@/components/Layout";
import { fmtRM } from "@/lib/format";
import { Trash2 } from "lucide-react";

const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, {
      year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export default function DeletedLoans() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/deleted-loans").then((r) => setRows(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <PageHeader
        title="Deleted Loans"
        subtitle="Audit trail of removed loans — who deleted what, when, and the cash reversed"
      />

      <div className="bg-white border border-slate-200 rounded-lg shadow-sm overflow-x-auto">
        <table className="w-full text-sm" data-testid="deleted-loans-table">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wider text-slate-500 bg-slate-50">
              <th className="px-5 py-3 font-medium">Deleted At</th>
              <th className="px-3 py-3 font-medium">Loan</th>
              <th className="px-3 py-3 font-medium">Customer</th>
              <th className="px-3 py-3 font-medium text-right">Loan Amount</th>
              <th className="px-3 py-3 font-medium text-right">Outstanding</th>
              <th className="px-3 py-3 font-medium text-right">Paid (#)</th>
              <th className="px-3 py-3 font-medium text-right">Cash Reversed</th>
              <th className="px-5 py-3 font-medium">Deleted By</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.logId} data-testid={`deleted-loan-row-${r.loanCode}`} className="border-b border-slate-50 hover:bg-slate-50">
                <td className="px-5 py-3 text-slate-600 whitespace-nowrap">{fmtDateTime(r.deletedAt)}</td>
                <td className="px-3 py-3 font-mono-fig font-medium text-slate-900">{r.loanCode}</td>
                <td className="px-3 py-3 text-slate-700">{r.customerName || "—"}</td>
                <td className="px-3 py-3 text-right font-mono-fig text-slate-800">{fmtRM(r.loanApply)}</td>
                <td className="px-3 py-3 text-right font-mono-fig text-amber-600">{fmtRM(r.outstanding)}</td>
                <td className="px-3 py-3 text-right font-mono-fig text-slate-600">{fmtRM(r.paymentsTotal)} ({r.paymentsCount})</td>
                <td className="px-3 py-3 text-right font-mono-fig text-red-600">{fmtRM(r.reversedDisbursement)}</td>
                <td className="px-5 py-3 text-slate-700">{r.deletedByName || r.deletedBy}</td>
              </tr>
            ))}
            {!loading && rows.length === 0 && (
              <tr>
                <td colSpan={8} className="px-5 py-14 text-center text-slate-400">
                  <Trash2 className="h-6 w-6 mx-auto mb-2 text-slate-300" />
                  No loans have been deleted yet.
                </td>
              </tr>
            )}
            {loading && <tr><td colSpan={8} className="px-5 py-12 text-center text-slate-400 animate-pulse">Loading…</td></tr>}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
